/* eslint-disable camelcase */
import {
  ModelParam,
  ModelParamAutoRoof, ModelParamHeight, ModelParamOption, ModelParamSAutoTategu,
} from './types';

export default class Option {
        public tumaKazari: number;

        public flowerBox: number;

        public desumiSousyoku: number;

        public yoroido: number;

        public menGousi: number;

        public timber: number;

        public hisasi: number;

        public oriage: number;

        public kesyoHari: number;

        public makuita: number;

        public madowaku: number;

        public balconyTesuri: number;

        public lighting: number

        public suihei_nokiten: boolean;

        constructor() {
          this.Init();
        }

        public Init() {
          this.tumaKazari = 0;
          this.flowerBox = 0;
          this.desumiSousyoku = 0;
          this.yoroido = 0;
          this.menGousi = 0;
          this.timber = 0;
          this.hisasi = 0;
          this.oriage = 0;
          this.kesyoHari = 0;
          this.makuita = 0;
          this.madowaku = 0;
          this.balconyTesuri = 0;
          this.lighting = 1;
          this.suihei_nokiten = true;
        }

        /* ------------------------------------------------------
        * [JSON] option の読み込み
        */
        public readJSON(option:ModelParamOption) {
          if (option && Object.keys(option).length !== 0) {
            this.tumaKazari = option.tuma_kazari;
            this.flowerBox = option.flower_box;
            this.desumiSousyoku = option.desumi_sousyoku;
            this.yoroido = option.yoroido;
            this.menGousi = option.men_gousi;
            this.timber = option.timber;
            this.hisasi = option.hisasi;
            this.oriage = option.oriage;
            this.kesyoHari = option.kesyo_hari;
            this.makuita = option.makuita;
            this.madowaku = option.madowaku;
            this.balconyTesuri = option.balcony_tesuri;
            this.lighting = option.lighting !== undefined ? option.lighting : this.lighting;
            this.suihei_nokiten = option.suihei_nokiten !== undefined ? option.suihei_nokiten : this.suihei_nokiten;
          }
        }

        /*------------------------------------------------------
        * [JSON] option の書き出し
        */
        public writeJSON(): ModelParamOption {
          const dataOption = <ModelParamOption> {};
          dataOption.tuma_kazari = this.tumaKazari;
          dataOption.flower_box = this.flowerBox;
          dataOption.desumi_sousyoku = this.desumiSousyoku;
          dataOption.yoroido = this.yoroido;
          dataOption.men_gousi = this.menGousi;
          dataOption.timber = this.timber;
          dataOption.hisasi = this.hisasi;
          dataOption.oriage = this.oriage;
          dataOption.kesyo_hari = this.kesyoHari;
          dataOption.makuita = this.makuita;
          dataOption.madowaku = this.madowaku;
          dataOption.balcony_tesuri = this.balconyTesuri;
          dataOption.lighting = this.lighting;
          dataOption.suihei_nokiten = this.suihei_nokiten;
          return dataOption;
        }
}

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*------------------------------------------------------
    * コンストラクタ
    *
    * new ConstructionModelHeight();
    */
export class ConstructionModelHeight {
        public slabLevel1: number;

        public slabLevel2: number;

        public slabLevel3: number;

        public slabLevel4: number;

        public floor1: number;

        public floor2: number;

        public floor3: number;

        public ceiling1: number;

        public ceiling2: number;

        public ceiling3: number;

        public baseLevel: number;

        public packin: number;

        public entranceLevel: number;

        public porchLevel: number;

        public outWaist1: number;

        public outWaist2: number;

        public outWaist3: number;

        public handrailHeight: number;

        public entranceDoorHeight: number;

        public sasiHeight: number;

        public doorHeight: number;

        public fallingWallHeight: number;

        public habakiHeight: number;

        public roomWaist: number;

        constructor() {
          this.Init();
        }

        public Init() {
          this.slabLevel1 = 525;
          this.slabLevel2 = 3405;
          this.slabLevel3 = 6225;
          this.slabLevel4 = 9025;
          this.floor1 = 40;
          this.floor2 = 40;
          this.floor3 = 40;
          this.ceiling1 = 2425;
          this.ceiling2 = 2425;
          this.ceiling3 = 2425;
          this.baseLevel = 400;
          this.packin = 20;
          this.entranceLevel = 335;
          this.porchLevel = 325;
          this.outWaist1 = 800;
          this.outWaist2 = 800;
          this.outWaist3 = 800;
          this.handrailHeight = 1100;
          this.entranceDoorHeight = 2400;
          this.sasiHeight = 2400;
          this.doorHeight = 2000;
          this.fallingWallHeight = 2100;
          this.habakiHeight = 50;
          this.roomWaist = 800;
        }

        /* ------------------------------------------------------
        * [JSON] model_param の読み込み
        */
        public readJSONnode(node:ModelParamHeight) {
          if (node && Object.keys(node).length !== 0) {
            this.slabLevel1 = node.slab_level1;
            this.slabLevel2 = node.slab_level2;
            this.slabLevel3 = node.slab_level3;
            this.slabLevel4 = node.slab_level4;
            this.floor1 = node.floor1;
            this.floor2 = node.floor2;
            this.floor3 = node.floor3;
            this.ceiling1 = node.ceiling1;
            this.ceiling2 = node.ceiling2;
            this.ceiling3 = node.ceiling3;
            this.baseLevel = node.base_level;
            this.packin = node.packin ? node.packin : 0;
            this.entranceLevel = node.entrance_level;
            this.porchLevel = node.porch_level;
            this.outWaist1 = node.out_waist1;
            this.outWaist2 = node.out_waist2;
            this.outWaist3 = node.out_waist3;
            this.handrailHeight = node.handrail_height;
            this.entranceDoorHeight = node.entrance_door_height;
            this.sasiHeight = node.sasi_height;
            this.doorHeight = node.door_height;
            this.fallingWallHeight = node.falling_wall_height;
            this.habakiHeight = node.habaki_height;
            this.roomWaist = node.room_waist;
          }
        }

        /* ------------------------------------------------------
        * [JSON] model_param の読み込み
        */
        public readJSON(node:ModelParamHeight) {
          if (node && Object.keys(node).length !== 0) {
            this.slabLevel1 = node.slab_level1;
            this.slabLevel2 = node.slab_level2;
            this.slabLevel3 = node.slab_level3;
            this.slabLevel4 = node.slab_level4;
            this.floor1 = node.floor1;
            this.floor2 = node.floor2;
            this.floor3 = node.floor3;
            this.ceiling1 = node.ceiling1;
            this.ceiling2 = node.ceiling2;
            this.ceiling3 = node.ceiling3;
            this.baseLevel = node.base_level;
            this.packin = node.packin ? node.packin : 0;
            this.entranceLevel = node.entrance_level;
            this.porchLevel = node.porch_level;
            this.outWaist1 = node.out_waist1;
            this.outWaist2 = node.out_waist2;
            this.outWaist3 = node.out_waist3;
            this.handrailHeight = node.handrail_height;
            this.entranceDoorHeight = node.entrance_door_height;
            this.sasiHeight = node.sasi_height;
            this.doorHeight = node.door_height;
            this.fallingWallHeight = node.falling_wall_height;
            this.habakiHeight = node.habaki_height;
            this.roomWaist = node.room_waist;
          }
        }

        /*------------------------------------------------------
        * [JSON] model_param の書き出し
        */
        public writeJSON(): ModelParamHeight {
          const heightData = <ModelParamHeight>{};
          heightData.slab_level1 = this.slabLevel1;
          heightData.slab_level2 = this.slabLevel2;
          heightData.slab_level3 = this.slabLevel3;
          heightData.slab_level4 = this.slabLevel4;
          heightData.floor1 = this.floor1;
          heightData.floor2 = this.floor2;
          heightData.floor3 = this.floor3;
          heightData.ceiling1 = this.ceiling1;
          heightData.ceiling2 = this.ceiling2;
          heightData.ceiling3 = this.ceiling3;
          heightData.base_level = this.baseLevel;
          heightData.packin = this.packin;
          heightData.entrance_level = this.entranceLevel;
          heightData.porch_level = this.porchLevel;
          heightData.out_waist1 = this.outWaist1;
          heightData.out_waist2 = this.outWaist2;
          heightData.out_waist3 = this.outWaist3;
          heightData.handrail_height = this.handrailHeight;
          heightData.entrance_door_height = this.entranceDoorHeight;
          heightData.sasi_height = this.sasiHeight;
          heightData.door_height = this.doorHeight;
          heightData.falling_wall_height = this.fallingWallHeight;
          heightData.habaki_height = this.habakiHeight;
          heightData.room_waist = this.roomWaist;
          return heightData;
        }
}

/**
 * コンストラクタ
 */
export class ConstructionModelAutoRoof {
        public auto: number;

        public roofType: number;

        public slope: number;

        public nokide: number;

        public tumade: number;

        public hanaHeight: number;

        public sumiWidth: number;

        public sumiHeight: number;

        constructor() {
          this.auto = 1;
          this.roofType = 1;
          this.slope = 4.5;
          this.nokide = 400;
          this.tumade = 350;
          this.hanaHeight = 180;
          this.sumiWidth = 50;
          this.sumiHeight = 20;
        }

        /*------------------------------------------------------
        * [JSON] model_param の読み込み
        */
        public readJSON(node:ModelParamAutoRoof) {
          if (node && Object.keys(node).length !== 0) {
            this.auto = node.auto;
            this.roofType = node.roof_type;
            this.slope = node.slope;
            this.nokide = node.nokide;
            this.tumade = node.tumade;
            this.hanaHeight = node.hana_height;
            this.sumiWidth = node.sumi_width;
            this.sumiHeight = node.sumi_height;
          }
        }

        /*------------------------------------------------------
        * [JSON] model_param の読み込み
        */
        public readKijyunJSON(node:ModelParamAutoRoof) {
          if (node && Object.keys(node).length !== 0) {
            this.slope = node.slope;
            this.nokide = node.nokide;
            this.tumade = node.tumade;
            this.hanaHeight = node.hana_height;
          }
        }

        /*------------------------------------------------------
        * [JSON] SAutoRoof の書き出し
        */
        public writeJSON(): ModelParamAutoRoof {
          const data = <ModelParamAutoRoof>{};
          data.auto = this.auto;
          data.roof_type = this.roofType;
          data.slope = this.slope;
          data.nokide = this.nokide;
          data.tumade = this.tumade;
          data.hana_height = this.hanaHeight;
          data.sumi_width = this.sumiWidth;
          data.sumi_height = this.sumiHeight;
          return data;
        }
}
/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*------------------------------------------------------
    * コンストラクタ
    *
    * new SAutoTategu();
    */
export class SAutoTategu {
        public auto: number;

        constructor() {
          this.auto = 1;
        }

        /*------------------------------------------------------
        * [JSON] model_param の読み込み
        */
        public readJSON(node: ModelParamSAutoTategu) {
          if (node && Object.keys(node).length !== 0) {
            this.auto = node.auto;
          }
        }

        /*------------------------------------------------------
        * [JSON] SAutoTategu の書き出し
        */
        public writeJSON(): ModelParamSAutoTategu {
          const data = <ModelParamSAutoTategu>{};
          data.auto = this.auto;
          return data;
        }
}

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*------------------------------------------------------
    * コンストラクタ
    *
    * new STexture();
    */
class STexture {
    public name: string;

    public value: string;

    constructor(name:string = '', value:string = '') {
      this.name = name;
      this.value = value;
    }

    /*------------------------------------------------------
    * Textureの読み出し
    */
    public GetMaterialName(): string {
      return this.name;
    }

    /*------------------------------------------------------
    * Textureの書き込み
    */
    public SetMaterialName(name: string) {
      this.name = name;
    }

    /*------------------------------------------------------
    * Textureの読み出し
    */
    public GetMaterialValue(): string {
      return this.value;
    }

    /*------------------------------------------------------
    * Textureの書き込み
    */
    public SetMaterialValue(value: string) {
      this.value = value;
    }

    /*------------------------------------------------------
    * [JSON] model_param の読み込み
    */
    public readJSON(node: STexture) {
      if (node && Object.keys(node).length !== 0) {
        this.name = node.name;
        this.value = node.value;
      }
    }
}

class SMaterialBase {
  initialData:STexture[] = [];

  materialDataList:STexture[] = [];

  constructor() {
    this.materialDataList = [];
  }

  /*------------------------------------------------------
    * Textureの初期化
    */
  public Init() {
    this.materialDataList = Object.assign([], this.initialData);
  }

  /*------------------------------------------------------
        * Textureの読み出し
        */
  public GetMaterialName(categ: string): string {
    const material = this.materialDataList.find((mat:STexture) => mat.name === categ);
    return material ? material.value : '';
  }

  /*------------------------------------------------------
        * Textureの書き込み
        */
  public SetMaterialName(categ: string, value: string) {
    const material = this.materialDataList.find((mat:STexture) => mat.name === categ);
    if (material) material.value = value;
    else if (this.initialData.find((mat:STexture) => mat.name === categ)) this.materialDataList.push(new STexture(categ, value));
  }

  /*------------------------------------------------------
    * [JSON] model_param の読み込み
    */
  public readJSON(list) {
    if (list.length > 0) {
      const merged = [];
      for (let i = 0; i < this.materialDataList.length; i += 1) {
        merged.push({
          ...this.materialDataList[i],
          ...(list.find((itmInner) => itmInner.name === this.materialDataList[i].name)),
        });
      }
      const newValues = list.filter((item) => !this.initialData.find((it) => it.name === item.name));
      if (newValues.length > 0)merged.push(...newValues);
      this.materialDataList = merged;
    }
  }

  /*------------------------------------------------------
    * [JSON] model_param の書き出し
    */
  public writeJSON(): STexture[] {
    return this.materialDataList;
  }
}

/**
 *  コンストラクタ
 * new SOutMate01();
 */
class SOutMate01 extends SMaterialBase {
  constructor() {
    super();
    this.initialData = [
      new STexture('mune', 'dark_mat'),
      new STexture('roof', 'roof_img'),
      new STexture('hana', 'dark_mat'),
      new STexture('tuma', 'dark_mat'),
      new STexture('nokiura', 'dark_mat'),
      new STexture('wall', 'white_img'),
      new STexture('kosi', 'black_img'),
      new STexture('balcony', 'white_img'),
      new STexture('porch', 'outtile_img'),
      new STexture('base', 'base_img'),
      new STexture('timber', 'timber_brown'),
      new STexture('makuita', 'makuita_brown'),
      new STexture('madowaku', 'madowaku_brown'),
    ];
  }
}

/*------------------------------------------------------
    * コンストラクタ
    *
    * new SOutMate();
    */
class SOutMate extends SMaterialBase {
  /*------------------------------------------------------
    * Textureの初期化
    */
  constructor() {
    super();
    this.initialData = [
      new STexture('mune', 'dark_mat'),
      new STexture('roof', 'roof_img'),
      new STexture('hana', 'dark_mat'),
      new STexture('tuma', 'dark_mat'),
      new STexture('nokiura', 'dark_mat'),
      new STexture('wall', 'white_img'),
      new STexture('kosi', 'black_img'),
      new STexture('balcony', 'white_img'),
      new STexture('timber', 'timber_brown'),
      new STexture('makuita', 'makuita_brown'),
      new STexture('madowaku', 'madowaku_brown'),
    ];
  }
}

/*------------------------------------------------------
    * コンストラクタ
    *
    * new AutoRoomMate();
    */
class AutoRoomMate extends SMaterialBase {
  constructor() {
    super();
    this.initialData = [
      new STexture('ceiling', 'cloth_img'),
      new STexture('wall', 'cloth_img'),
      new STexture('kosi', 'cloth_img'),
      new STexture('habaki', 'floor1_img'),
      new STexture('floor', 'floor1_img'),
    ];
  }
}

/*------------------------------------------------------
  * コンストラクタ
  *
  * new STateguColor();
  */
class STateguMaterial extends SMaterialBase {
  constructor() {
    super();
    this.initialData = [
      new STexture('body', 'door_body_mat'),
      new STexture('glass', 'glass_mat'),
      new STexture('gakubuti', ''),
      new STexture('kanamono', 'metal_mat'),
      new STexture('curtain', ''),
    ];
  }
}

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*------------------------------------------------------
    * コンストラクタ
    *
    * new Material();
    */
export class MaterialParam {
  public name: string;

  public value: string;

  constructor() {
    this.name = '';
    this.value = '';
  }

  /*------------------------------------------------------
  * Textureの読み出し
  */
  public SameName(name) {
    if (name === this.name) {
      return true;
    }
    return false;
  }
}

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*------------------------------------------------------
    * コンストラクタ
    *
    * new Material();
    */
export class SMaterial {
  public name: string;

  public param: Array<MaterialParam>;

  constructor() {
    this.name = '';
    this.param = [];
  }

  /*------------------------------------------------------
  * Material パラメータの変更、追加
  */
  public AddParam(name: string, val: string) {
    for (let i = 0; i < this.param.length; i += 1) {
      if (this.param[i].SameName(name) === true) {
        // パラメータ名が見つかったので、値を書き換える
        this.param[i].value = val;
        return;
      }
    }
    // パラメータ名が見つからないので、新しく追加する
    const pr = new MaterialParam();
    pr.name = name;
    pr.value = val;
    this.param.push(pr);
  }

  /*------------------------------------------------------
  * Material パラメータの取得
  */
  public GetParam(name: string): string {
    for (let i = 0; i < this.param.length; i += 1) {
      if (this.param[i].SameName(name) === true) {
        // パラメータ名が見つかったので、値の文字列を返す
        return this.param[i].value;
      }
    }
    // パラメータ名が見つからないので、空文字列を返す
    return '';
  }

  /*------------------------------------------------------
  * XMLの読み込み
  */
  public readXML(item) {
    const rattr = item.attributes;
    this.name = rattr.getNamedItem('name').nodeValue;

    const list = item.getElementsByTagName('param');
    for (let i = 0; i < list.length; i += 1) {
      const pl = list[i].attributes;
      const mate = new MaterialParam();
      mate.name = pl.getNamedItem('name').nodeValue;
      mate.value = pl.getNamedItem('value').nodeValue;
      this.param.push(mate);
    }
  }
}

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*------------------------------------------------------
    * コンストラクタ
    *
    * new ConstructionModel();
    */
export class ConstructionModel {
        public Height: ConstructionModelHeight;

        public AutoRoof: ConstructionModelAutoRoof;

        public AutoTategu: SAutoTategu;

        public Out01: SOutMate01;

        private Out02: SOutMate;

        private Out03: SOutMate;

        public Interior: AutoRoomMate;

        private Room02: AutoRoomMate;

        private Room03: AutoRoomMate;

        private Room04: AutoRoomMate;

        private Room05: AutoRoomMate;

        private Room06: AutoRoomMate;

        private Room07: AutoRoomMate;

        private Room08: AutoRoomMate;

        private Room09: AutoRoomMate;

        private Room10: AutoRoomMate;

        private Room11: AutoRoomMate;

        private Room12: AutoRoomMate;

        private Room13: AutoRoomMate;

        private Room14: AutoRoomMate;

        private Room15: AutoRoomMate;

        private Room16: AutoRoomMate;

        private Room17: AutoRoomMate;

        private Room18: AutoRoomMate;

        private Room24: AutoRoomMate;

        private Room25: AutoRoomMate;

        private Room26: AutoRoomMate;

        private Room27: AutoRoomMate;

        private Room28: AutoRoomMate;

        private Room38: AutoRoomMate;

        private Room39: AutoRoomMate;

        private Room40: AutoRoomMate;

        private Room41: AutoRoomMate;

        private Room42: AutoRoomMate;

        private Room43: AutoRoomMate;

        private Room44: AutoRoomMate;

        private Room45: AutoRoomMate;

        public Door: STateguMaterial;

        public Sash: STateguMaterial;

        public Ent: STateguMaterial;

        public Shutter: STateguMaterial;

        public MaterialList: Array<SMaterial>;

        public Option: Option;

        constructor() {
          this.Height = new ConstructionModelHeight();

          this.AutoRoof = new ConstructionModelAutoRoof();
          this.AutoTategu = new SAutoTategu();

          this.Out01 = new SOutMate01();
          this.Out02 = new SOutMate();
          this.Out03 = new SOutMate();

          this.Interior = new AutoRoomMate();
          this.Room02 = new AutoRoomMate();
          this.Room03 = new AutoRoomMate();
          this.Room04 = new AutoRoomMate();
          this.Room05 = new AutoRoomMate();
          this.Room06 = new AutoRoomMate();
          this.Room07 = new AutoRoomMate();
          this.Room08 = new AutoRoomMate();
          this.Room09 = new AutoRoomMate();
          this.Room10 = new AutoRoomMate();
          this.Room11 = new AutoRoomMate();
          this.Room12 = new AutoRoomMate();
          this.Room13 = new AutoRoomMate();
          this.Room14 = new AutoRoomMate();
          this.Room15 = new AutoRoomMate();
          this.Room16 = new AutoRoomMate();
          this.Room17 = new AutoRoomMate();
          this.Room18 = new AutoRoomMate();
          this.Room24 = new AutoRoomMate();
          this.Room25 = new AutoRoomMate();
          this.Room26 = new AutoRoomMate();
          this.Room27 = new AutoRoomMate();
          this.Room28 = new AutoRoomMate();

          this.Room38 = new AutoRoomMate();
          this.Room39 = new AutoRoomMate();
          this.Room40 = new AutoRoomMate();
          this.Room41 = new AutoRoomMate();
          this.Room42 = new AutoRoomMate();
          this.Room43 = new AutoRoomMate();
          this.Room44 = new AutoRoomMate();
          this.Room45 = new AutoRoomMate();

          this.Door = new STateguMaterial();
          this.Sash = new STateguMaterial();
          this.Ent = new STateguMaterial();
          this.Shutter = new STateguMaterial();

          this.MaterialList = [];
          this.Option = new Option();
        }

        /*------------------------------------------------------
        * [XML] model_param の読み込み
        */
        public Init() {
          this.Height.Init();
          this.InitMaterial();
        }

        /*------------------------------------------------------
        * マテリアルだけの初期化（高さは触らない）
        */
        private InitMaterial(): void {
          this.Out01.Init();
          this.Out02.Init();
          this.Out03.Init();

          this.Interior.Init();
          this.Room02.Init();
          this.Room03.Init();
          this.Room04.Init();
          this.Room05.Init();
          this.Room06.Init();
          this.Room07.Init();
          this.Room08.Init();
          this.Room09.Init();
          this.Room10.Init();
          this.Room11.Init();
          this.Room12.Init();
          this.Room13.Init();
          this.Room14.Init();
          this.Room15.Init();
          this.Room16.Init();
          this.Room17.Init();
          this.Room18.Init();
          this.Room24.Init();
          this.Room25.Init();
          this.Room26.Init();
          this.Room27.Init();
          this.Room28.Init();

          this.Room38.Init();
          this.Room39.Init();
          this.Room40.Init();
          this.Room41.Init();
          this.Room42.Init();
          this.Room43.Init();
          this.Room44.Init();
          this.Room45.Init();

          this.Door.Init();

          this.Sash.Init();
          this.Sash.SetMaterialName('body', 'sash1_body_mat');

          this.Ent.Init();
          this.Ent.SetMaterialName('body', 'ent1_body_mat');

          this.Shutter.Init();
          this.Shutter.SetMaterialName('body', 'sash1_body_mat');
        }

        public getOutMaterial(floor: number) : SOutMate | SOutMate01{
            return ([this.Out01, this.Out02, this.Out03])[floor-1];
        }

        /*------------------------------------------------------
        * [Model Height propaty] SlabLevel1 土台天端
        */
        public SetSlabLevel1(val: number) {
          this.Height.slabLevel1 = val;
        }

        public GetSlabLevel1(): number {
          return this.Height.slabLevel1;
        }

        /*------------------------------------------------------
        * [Model Height propaty] SlabLevel2 １階軒高
        */
        public SetSlabLevel2(val: number) {
          this.Height.slabLevel2 = val;
        }

        public GetSlabLevel2(): number {
          return this.Height.slabLevel2;
        }

        /*------------------------------------------------------
        * [Model Height propaty] SlabLevel3 ２階軒高
        */
        public SetSlabLevel3(val: number) {
          this.Height.slabLevel3 = val;
        }

        public GetSlabLevel3(): number {
          return this.Height.slabLevel3;
        }

        /*------------------------------------------------------
        * [Model Height propaty] SlabLevel4 ３階軒高
        */
        public SetSlabLevel4(val: number) {
          this.Height.slabLevel4 = val;
        }

        public GetSlabLevel4(): number {
          return this.Height.slabLevel4;
        }

        /*------------------------------------------------------
        * [Model Height propaty] Floor1 １階床高（slab_level1 からの高さ）
        */
        public SetFloor1(val: number) {
          this.Height.floor1 = val;
        }

        public GetFloor1(): number {
          return this.Height.floor1;
        }

        /*------------------------------------------------------
        * [Model Height propaty] Floor2 ２階床高（slab_level2 からの高さ）
        */
        public SetFloor2(val: number) {
          this.Height.floor2 = val;
        }

        public GetFloor2(): number {
          return this.Height.floor2;
        }

        /*------------------------------------------------------
        * [Model Height propaty] Floor3 ３階床高（slab_level3 からの高さ）
        */
        public SetFloor3(val: number) {
          this.Height.floor3 = val;
        }

        public GetFloor3(): number {
          return this.Height.floor3;
        }

        /*------------------------------------------------------
        * [Model Height propaty] Ceiling1 １階天井高（floor1 からの高さ）
        */
        public SetCeiling1(val: number) {
          this.Height.ceiling1 = val;
        }

        public GetCeiling1(): number {
          return this.Height.ceiling1;
        }

        /*------------------------------------------------------
        * [Model Height propaty] Ceiling2 ２階天井高（floor2 からの高さ）
        */
        public SetCeiling2(val: number) {
          this.Height.ceiling2 = val;
        }

        public GetCeiling2(): number {
          return this.Height.ceiling2;
        }

        /*------------------------------------------------------
        * [Model Height propaty] Ceiling3 ３階天井高（floor3 からの高さ）
        */
        public SetCeiling3(val: number) {
          this.Height.ceiling3 = val;
        }

        public GetCeiling3(): number {
          return this.Height.ceiling3;
        }

        /*------------------------------------------------------
        * [Model Height propaty] BaseLevel 基礎高（地巾木高さ＝ＧＬから上の高さ）
        */
        public SetBaseLevel(val: number) {
          this.Height.baseLevel = val;
        }

        public GetBaseLevel(): number {
          return this.Height.baseLevel;
        }

        /*------------------------------------------------------
        * [Model Height propaty] packin 基礎パッキン（パッキン厚）
        */
        public SetBasePackin(val: number) {
          this.Height.packin = val;
        }

        public GetBasePackin(): number {
          return this.Height.packin;
        }

        /*------------------------------------------------------
        * [Model Height propaty] BaseLevel 玄関床高
        */
        public SetEntranceLevel(val: number) {
          this.Height.entranceLevel = val;
        }

        public GetEntranceLevel(): number {
          return this.Height.entranceLevel;
        }

        /*------------------------------------------------------
        * [Model Height propaty] PorchLevel ポーチ高
        */
        public SetPorchLevel(val: number) {
          this.Height.porchLevel = val;
        }

        public GetPorchLevel(): number {
          return this.Height.porchLevel;
        }

        /*------------------------------------------------------
        * [Model Height propaty] OutWaist1 1階外壁張り分け高さ (slab_level1 からの高さ）
        */
        public SetOutWaist1(val: number) {
          this.Height.outWaist1 = val;
        }

        public GetOutWaist1(): number {
          return this.Height.outWaist1;
        }

        /*------------------------------------------------------
        * [Model Height propaty] OutWaist2 2階外壁張り分け高さ (slab_level2 からの高さ）
        */
        public SetOutWaist2(val: number) {
          this.Height.outWaist2 = val;
        }

        public GetOutWaist2(): number {
          return this.Height.outWaist2;
        }

        /*------------------------------------------------------
        * [Model Height propaty] OutWaist3 3階外壁張り分け高さ (slab_level3 からの高さ）
        */
        public SetOutWaist3(val: number) {
          this.Height.outWaist3 = val;
        }

        public GetOutWaist3(): number {
          return this.Height.outWaist3;
        }

        /*------------------------------------------------------
        * [Model Height propaty] HandrailHeight 手摺壁高さ (各階床 からの高さ）(バルコニー手摺と共通)
        */
        public SetHandrailHeight(val: number) {
          this.Height.handrailHeight = val;
        }

        public GetHandrailHeight(): number {
          return this.Height.handrailHeight;
        }

        /*------------------------------------------------------
        * [Model Height propaty] EntranceDoorHeight 玄関扉取り付け高 (玄関床高 からの高さ）
        */
        public SetEntranceDoorHeight(val: number) {
          this.Height.entranceDoorHeight = val;
        }

        public GetEntranceDoorHeight(): number {
          return this.Height.handrailHeight;
        }

        /*------------------------------------------------------
        * [Model Height propaty] SasiHeight サッシ取り付け高 (各階床高 からの高さ）
        */
        public SetSasiHeight(val: number) {
          this.Height.sasiHeight = val;
        }

        public GetSasiHeight(): number {
          return this.Height.sasiHeight;
        }

        /*------------------------------------------------------
        * [Model Height propaty] DoorHeight 内部建具取り付け高 (各階床高 からの高さ）
        */
        public SetDoorHeight(val: number) {
          this.Height.doorHeight = val;
        }

        public GetDoorHeight(): number {
          return this.Height.doorHeight;
        }

        /*------------------------------------------------------
        * [Model Height propaty] FallingWallHeight 下り壁下端高 (各階床高 からの高さ）
        */
        public SetFallingWallHeight(val: number) {
          this.Height.fallingWallHeight = val;
        }

        public GetFallingWallHeight(): number {
          return this.Height.fallingWallHeight;
        }

        /*------------------------------------------------------
        * [Model Height propaty] HabakiHeight 巾木高 (各階床高 からの高さ）
        */
        public SetHabakiHeight(val: number) {
          this.Height.habakiHeight = val;
        }

        public GetHabakiHeight(): number {
          return this.Height.habakiHeight;
        }

        /*------------------------------------------------------
        * [Model Height propaty] RoomWaist 内壁張り分け高さ (各階床高 からの高さ）
        */
        public SetRoomWaist(val: number) {
          this.Height.roomWaist = val;
        }

        public GetRoomWaist(): number {
          return this.Height.roomWaist;
        }

        /*------------------------------------------------------
        * 初期値

        this.roof_type = "1";
        this.slope = "4.5";
        this.nokide = "400";
        this.tumade = "350";
        this.hana_height = "180";
        this.sumi_width = "50";
        this.sumi_height = "20";
        */

        /*------------------------------------------------------
        * [Auto Roof propaty] AutoRoofType 自動屋根 屋根形状
        *   "1":寄棟 "2":横切妻 "3":縦切妻
        */
        public SetAutoRoofType(val: number) {
          this.AutoRoof.roofType = val;
        }

        public GetAutoRoofType(): number {
          return this.AutoRoof.roofType;
        }

        /*------------------------------------------------------
        * [Auto Roof propaty] AutoRoofSlope 自動屋根 勾配
        */
        public SetAutoRoofSlope(val: number) {
          this.AutoRoof.slope = val;
        }

        public GetAutoRoofSlope(): number {
          return this.AutoRoof.slope;
        }

        /*------------------------------------------------------
        * [Auto Roof propaty] AutoRoofNokide 自動屋根 軒出
        */
        public SetAutoRoofNokide(val: number) {
          this.AutoRoof.nokide = val;
        }

        public GetAutoRoofNokide(): number {
          return this.AutoRoof.nokide;
        }

        /*------------------------------------------------------
        * [Auto Roof propaty] AutoRoofTumade 自動屋根 妻出
        */
        public SetAutoRoofTumade(val: number) {
          this.AutoRoof.tumade = val;
        }

        public GetAutoRoofTumade(): number {
          return this.AutoRoof.tumade;
        }

        /*------------------------------------------------------
        * [Auto Roof propaty] AutoRoofHanaHeight 自動屋根 鼻隠高（軒先の高さ）
        */
        public SetAutoRoofHanaHeight(val: number) {
          this.AutoRoof.hanaHeight = val;
        }

        public GetAutoRoofHanaHeight(): number {
          return this.AutoRoof.hanaHeight;
        }

        /*------------------------------------------------------
        * [Auto Roof propaty] AutoRoofSumiWidth 自動屋根 隅棟の幅（中心から片側の幅）
        */
        public SetAutoRoofSumiWidth(val: number) {
          this.AutoRoof.sumiWidth = val;
        }

        public GetAutoRoofSumiWidth(): number {
          return this.AutoRoof.sumiWidth;
        }

        /*------------------------------------------------------
        * [Auto Roof propaty] AutoRoofSumiHeight 自動屋根 隅棟の高さ（屋根面からの高さ）
        */
        public SetAutoRoofSumiHeight(val: number) {
          this.AutoRoof.sumiHeight = val;
        }

        public GetAutoRoofSumiHeight(): number {
          return this.AutoRoof.sumiHeight;
        }

        /*------------------------------------------------------
        * [3D Model] マテリアルパラメータをXMLから読み込む
        */
        public readMaterialList(itemList) {
          for (let i = 0; i < itemList.length; i += 1) {
            const mate = new SMaterial();
            mate.readXML(itemList[i]);
            this.MaterialList.push(mate);
          }
        }

        /*------------------------------------------------------
        * [3D Model] マテリアルパラメータをクリエイトする
        */
        public createMaterial(name: string): SMaterial {
          for (let i = 0; i < this.MaterialList.length; i += 1) {
            if (this.MaterialList[i].name === name) {
              // 同名のマテリアルがすでにある
              return this.MaterialList[i];
            }
          }
          const mate = new SMaterial();
          mate.name = name;
          this.MaterialList.push(mate);
          return mate;
        }

        /*------------------------------------------------------
        * [3D Model] マテリアルパラメータを探す
        */
        public searchMaterial(name: string): SMaterial {
          for (let i = 0; i < this.MaterialList.length; i += 1) {
            if (this.MaterialList[i].name === name) {
              // 同名のマテリアルがある
              return this.MaterialList[i];
            }
          }
          return null;
        }

        /*------------------------------------------------------
        * 高さ設定オプションをXMLに書き出す
        */
        public createOptionXML(): ModelParamOption {
          const xml = this.Option.writeJSON();
          return xml;
        }

        /*------------------------------------------------------
        * [XML] model_param の読み込み
        */
        public readHeightXML(node) {
          if (node.length > 0) {
            this.Height.readJSON(node);
            this.AutoRoof.readKijyunJSON(node);
          }
        }

        /*------------------------------------------------------
        * [XML] model_auto の読み込み
        */
        public readAutoXML(node) {
          if (node.length > 0) {
            this.AutoRoof.readJSON(node);
          }
        }

        /*------------------------------------------------------
        * [XML] model_height の読み込み
        */
        public readModelHeightXML(node) {
          if (node != null) {
            this.Height.readJSONnode(node);
          }
        }

        /*------------------------------------------------------
        * [XML] model_param の読み込み
        */
        public readJSON(node) {
          if (node.length === 0) {
            this.Init();
            return;
          }

          if (node.option && node.option !== null) {
            this.Option.readJSON(node.option);
          }

          if (node.height && node.height !== null) {
            this.Height.readJSON(node.height);
          }
          const modelAuto = node.auto;
          if (modelAuto && modelAuto !== null) {
            if (modelAuto.a_roof && modelAuto.a_roof !== null) {
              this.AutoRoof.readJSON(modelAuto.a_roof);
            }

            const autoTategu = modelAuto.a_tategu;
            if (autoTategu && autoTategu !== null) {
              this.AutoTategu.readJSON(autoTategu);
            }
          }
          const modelMaterial = node.material;
          if (!modelMaterial || modelMaterial.length === 0) {
            // 直前に読んだ高さを残すため、マテリアルだけを初期化する
            this.InitMaterial();
          } else {
            const out = modelMaterial.find((mat) => mat.name === 'out01');
            if (out && out.list.length > 0) {
              this.Out01.readJSON(out.list);
            } else {
              this.Out01.Init();
            }
            const out2 = modelMaterial.find((mat) => mat.name === 'out02');
            if (out2 && out2.list.length > 0) {
              this.Out02.readJSON(out2.list);
            } else {
              this.Out02.Init();
            }
            const out3 = modelMaterial.find((mat) => mat.name === 'out03');
            if (out3 && out3.list.length > 0) {
              this.Out03.readJSON(out3.list);
            } else {
              this.Out03.Init();
            }

            const romX = modelMaterial.find((mat) => mat.name === 'interior');
            if (romX && romX.list.length > 0) {
              this.Interior.readJSON(romX.list);
            }

            const rom2 = modelMaterial.find((mat) => mat.name === 'rom02');
            if (rom2 && rom2.list.length > 0) {
              this.Room02.readJSON(rom2.list);
            } else {
              this.Room02.Init();
            }
            const rom3 = modelMaterial.find((mat) => mat.name === 'rom03');
            if (rom3 && rom3.list.length > 0) {
              this.Room03.readJSON(rom3.list);
            } else {
              this.Room03.Init();
            }
            const rom4 = modelMaterial.find((mat) => mat.name === 'rom04');
            if (rom4 && rom4.list.length > 0) {
              this.Room04.readJSON(rom4.list);
            } else {
              this.Room04.Init();
            }
            const rom5 = modelMaterial.find((mat) => mat.name === 'rom05');
            if (rom5 && rom5.list.length > 0) {
              this.Room05.readJSON(rom5.list);
            } else {
              this.Room05.Init();
            }
            const rom6 = modelMaterial.find((mat) => mat.name === 'rom06');
            if (rom6 && rom6.list.length > 0) {
              this.Room06.readJSON(rom6.list);
            } else {
              this.Room06.Init();
            }
            const rom7 = modelMaterial.find((mat) => mat.name === 'rom07');
            if (rom7 && rom7.list.length > 0) {
              this.Room07.readJSON(rom7.list);
            } else {
              this.Room07.Init();
            }
            const rom8 = modelMaterial.find((mat) => mat.name === 'rom08');
            if (rom8 && rom8.list.length > 0) {
              this.Room08.readJSON(rom8.list);
            } else {
              this.Room08.Init();
            }
            const rom9 = modelMaterial.find((mat) => mat.name === 'rom09');
            if (rom9 && rom9.list.length > 0) {
              this.Room09.readJSON(rom9.list);
            } else {
              this.Room09.Init();
            }
            const rom10 = modelMaterial.find((mat) => mat.name === 'rom010');
            if (rom10 && rom10.list.length > 0) {
              this.Room10.readJSON(rom10.list);
            } else {
              this.Room10.Init();
            }
            const rom11 = modelMaterial.find((mat) => mat.name === 'rom011');
            if (rom11 && rom11.list.length > 0) {
              this.Room11.readJSON(rom11.list);
            } else {
              this.Room11.Init();
            }
            const rom12 = modelMaterial.find((mat) => mat.name === 'rom012');
            if (rom12 && rom12.list.length > 0) {
              this.Room12.readJSON(rom12.list);
            } else {
              this.Room12.Init();
            }
            const rom13 = modelMaterial.find((mat) => mat.name === 'rom013');
            if (rom13 && rom13.list.length > 0) {
              this.Room13.readJSON(rom13.list);
            } else {
              this.Room13.Init();
            }
            const rom14 = modelMaterial.find((mat) => mat.name === 'rom014');
            if (rom14 && rom14.list.length > 0) {
              this.Room14.readJSON(rom14.list);
            } else {
              this.Room14.Init();
            }
            const rom15 = modelMaterial.find((mat) => mat.name === 'rom015');
            if (rom15 && rom15.list.length > 0) {
              this.Room15.readJSON(rom15.list);
            } else {
              this.Room15.Init();
            }
            const rom16 = modelMaterial.find((mat) => mat.name === 'rom016');
            if (rom16 && rom16.list.length > 0) {
              this.Room16.readJSON(rom16.list);
            } else {
              this.Room16.Init();
            }
            const rom17 = modelMaterial.find((mat) => mat.name === 'rom017');
            if (rom17 && rom17.list.length > 0) {
              this.Room17.readJSON(rom17.list);
            } else {
              this.Room17.Init();
            }
            const rom18 = modelMaterial.find((mat) => mat.name === 'rom018');
            if (rom18 && rom18.list.length > 0) {
              this.Room18.readJSON(rom18.list);
            } else {
              this.Room18.Init();
            }
            const rom24 = modelMaterial.find((mat) => mat.name === 'rom024');
            if (rom24 && rom24.list.length > 0) {
              this.Room24.readJSON(rom24.list);
            } else {
              this.Room24.Init();
            }
            const rom25 = modelMaterial.find((mat) => mat.name === 'rom025');
            if (rom25 && rom25.list.length > 0) {
              this.Room25.readJSON(rom25.list);
            } else {
              this.Room25.Init();
            }
            const rom26 = modelMaterial.find((mat) => mat.name === 'rom026');
            if (rom26 && rom26.list.length > 0) {
              this.Room26.readJSON(rom26.list);
            } else {
              this.Room26.Init();
            }
            const rom27 = modelMaterial.find((mat) => mat.name === 'rom027');
            if (rom27 && rom27.list.length > 0) {
              this.Room27.readJSON(rom27.list);
            } else {
              this.Room27.Init();
            }
            const rom28 = modelMaterial.find((mat) => mat.name === 'rom028');
            if (rom28 && rom28.list.length > 0) {
              this.Room28.readJSON(rom28.list);
            } else {
              this.Room28.Init();
            }
            const rom38 = modelMaterial.find((mat) => mat.name === 'rom038');
            if (rom38 && rom38.list.length > 0) {
              this.Room38.readJSON(rom38.list);
            } else {
              this.Room38.Init();
            }
            const rom39 = modelMaterial.find((mat) => mat.name === 'rom039');
            if (rom39 && rom39.list.length > 0) {
              this.Room39.readJSON(rom39.list);
            } else {
              this.Room39.Init();
            }
            const rom40 = modelMaterial.find((mat) => mat.name === 'rom040');
            if (rom40 && rom40.list.length > 0) {
              this.Room40.readJSON(rom40.list);
            } else {
              this.Room40.Init();
            }
            const rom41 = modelMaterial.find((mat) => mat.name === 'rom041');
            if (rom41 && rom41.list.length > 0) {
              this.Room41.readJSON(rom41.list);
            } else {
              this.Room41.Init();
            }
            const rom42 = modelMaterial.find((mat) => mat.name === 'rom042');
            if (rom42 && rom42.list.length > 0) {
              this.Room42.readJSON(rom42.list);
            } else {
              this.Room42.Init();
            }
            const rom43 = modelMaterial.find((mat) => mat.name === 'rom043');
            if (rom43 && rom43.list.length > 0) {
              this.Room43.readJSON(rom43.list);
            } else {
              this.Room43.Init();
            }
            const rom44 = modelMaterial.find((mat) => mat.name === 'rom044');
            if (rom44 && rom44.list.length > 0) {
              this.Room44.readJSON(rom44.list);
            } else {
              this.Room44.Init();
            }
            const rom45 = modelMaterial.find((mat) => mat.name === 'rom045');
            if (rom45 && rom45.list.length > 0) {
              this.Room45.readJSON(rom45.list);
            } else {
              this.Room45.Init();
            }

            const door = modelMaterial.find((mat) => mat.name === 'door');
            if (door && door.list.length > 0) {
              this.Door.readJSON(door.list);
            } else {
              this.Door.Init();
            }

            const sash = modelMaterial.find((mat) => mat.name === 'sash');
            if (sash && sash.list.length > 0) {
              this.Sash.readJSON(sash.list);
            } else {
              this.Sash.Init();
              this.Sash.SetMaterialName('body', 'sash1_body_mat');
            }

            const ent = modelMaterial.find((mat) => mat.name === 'ent');
            if (ent && ent.list.length > 0) {
              this.Ent.readJSON(ent.list);
            } else {
              this.Ent.Init();
              this.Ent.SetMaterialName('body', 'ent1_body_mat');
            }

            const shutter = modelMaterial.find((mat) => mat.name === 'shutter');
            if (shutter && shutter.list.length > 0) {
              this.Shutter.readJSON(shutter.list);
            } else {
              this.Shutter.Init();
              this.Shutter.SetMaterialName('body', 'sash1_body_mat');
            }
          }
        }

        /*------------------------------------------------------
        * [XML] インテリアの値を全部屋に反映
        */
        private SetInteriorMat(categ: string, name: string) {
          this.SetMaterialName('rom02', categ, name);
          this.SetMaterialName('rom03', categ, name);
          this.SetMaterialName('rom04', categ, name);
          this.SetMaterialName('rom05', categ, name);
          this.SetMaterialName('rom06', categ, name);
          this.SetMaterialName('rom07', categ, name);
          this.SetMaterialName('rom08', categ, name);
          this.SetMaterialName('rom09', categ, name);
          this.SetMaterialName('rom10', categ, name);
          this.SetMaterialName('rom11', categ, name);
          this.SetMaterialName('rom12', categ, name);
          this.SetMaterialName('rom13', categ, name);
          this.SetMaterialName('rom14', categ, name);
          this.SetMaterialName('rom15', categ, name);
          this.SetMaterialName('rom16', categ, name);
          this.SetMaterialName('rom17', categ, name);
          this.SetMaterialName('rom18', categ, name);
          this.SetMaterialName('rom24', categ, name);
          this.SetMaterialName('rom25', categ, name);
          this.SetMaterialName('rom26', categ, name);
          this.SetMaterialName('rom27', categ, name);
          this.SetMaterialName('rom28', categ, name);
          this.SetMaterialName('rom38', categ, name);
          this.SetMaterialName('rom39', categ, name);
          this.SetMaterialName('rom40', categ, name);
          this.SetMaterialName('rom41', categ, name);
          this.SetMaterialName('rom42', categ, name);
          this.SetMaterialName('rom43', categ, name);
          this.SetMaterialName('rom44', categ, name);
          this.SetMaterialName('rom45', categ, name);
        }

        /*------------------------------------------------------
        * [XML] model_param の書き出し
        */
        public writeJSON(): ModelParam {
          const param = <ModelParam>{};

          param.option = this.Option.writeJSON();
          param.height = this.Height.writeJSON();
          param.auto = { a_roof: this.AutoRoof.writeJSON(), a_tategu: this.AutoTategu.writeJSON() };
          param.material = [];

          param.material.push({ name: 'out01', list: this.Out01.writeJSON() });
          param.material.push({ name: 'out02', list: this.Out02.writeJSON() });
          param.material.push({ name: 'out03', list: this.Out03.writeJSON() });
          param.material.push({ name: 'interior', list: this.Interior.writeJSON() });
          param.material.push({ name: 'rom02', list: this.Room02.writeJSON() });
          param.material.push({ name: 'rom03', list: this.Room03.writeJSON() });
          param.material.push({ name: 'rom04', list: this.Room04.writeJSON() });
          param.material.push({ name: 'rom05', list: this.Room05.writeJSON() });
          param.material.push({ name: 'rom06', list: this.Room06.writeJSON() });
          param.material.push({ name: 'rom07', list: this.Room07.writeJSON() });
          param.material.push({ name: 'rom08', list: this.Room08.writeJSON() });
          param.material.push({ name: 'rom09', list: this.Room09.writeJSON() });
          param.material.push({ name: 'rom10', list: this.Room10.writeJSON() });
          param.material.push({ name: 'rom11', list: this.Room11.writeJSON() });
          param.material.push({ name: 'rom12', list: this.Room12.writeJSON() });
          param.material.push({ name: 'rom13', list: this.Room13.writeJSON() });
          param.material.push({ name: 'rom14', list: this.Room14.writeJSON() });
          param.material.push({ name: 'rom15', list: this.Room15.writeJSON() });
          param.material.push({ name: 'rom16', list: this.Room16.writeJSON() });
          param.material.push({ name: 'rom17', list: this.Room17.writeJSON() });
          param.material.push({ name: 'rom18', list: this.Room18.writeJSON() });
          param.material.push({ name: 'rom24', list: this.Room24.writeJSON() });
          param.material.push({ name: 'rom25', list: this.Room25.writeJSON() });
          param.material.push({ name: 'rom26', list: this.Room26.writeJSON() });
          param.material.push({ name: 'rom27', list: this.Room27.writeJSON() });
          param.material.push({ name: 'rom28', list: this.Room28.writeJSON() });
          param.material.push({ name: 'rom38', list: this.Room38.writeJSON() });
          param.material.push({ name: 'rom39', list: this.Room39.writeJSON() });
          param.material.push({ name: 'rom40', list: this.Room40.writeJSON() });
          param.material.push({ name: 'rom41', list: this.Room41.writeJSON() });
          param.material.push({ name: 'rom42', list: this.Room42.writeJSON() });
          param.material.push({ name: 'rom43', list: this.Room43.writeJSON() });
          param.material.push({ name: 'rom44', list: this.Room44.writeJSON() });
          param.material.push({ name: 'rom45', list: this.Room45.writeJSON() });
          param.material.push({ name: 'door', list: this.Door.writeJSON() });
          param.material.push({ name: 'sash', list: this.Sash.writeJSON() });
          param.material.push({ name: 'ent', list: this.Ent.writeJSON() });
          param.material.push({ name: 'shutter', list: this.Shutter.writeJSON() });
          return param;
        }

        /*------------------------------------------------------
        * Textureの読み出し
        */
        public GetMaterialName(item: string, categ: string): string {
          switch (item) {
            case 'out01': return this.Out01.GetMaterialName(categ);
            case 'out02': return this.Out02.GetMaterialName(categ);
            case 'out03': return this.Out03.GetMaterialName(categ);
            case 'interior': return this.Interior.GetMaterialName(categ);
            case 'rom02': return this.Room02.GetMaterialName(categ);
            case 'rom03': return this.Room03.GetMaterialName(categ);
            case 'rom04': return this.Room04.GetMaterialName(categ);
            case 'rom05': return this.Room05.GetMaterialName(categ);
            case 'rom06': return this.Room06.GetMaterialName(categ);
            case 'rom07': return this.Room07.GetMaterialName(categ);
            case 'rom08': return this.Room08.GetMaterialName(categ);
            case 'rom09': return this.Room09.GetMaterialName(categ);
            case 'rom10': return this.Room10.GetMaterialName(categ);
            case 'rom11': return this.Room11.GetMaterialName(categ);
            case 'rom12': return this.Room12.GetMaterialName(categ);
            case 'rom13': return this.Room13.GetMaterialName(categ);
            case 'rom14': return this.Room14.GetMaterialName(categ);
            case 'rom15': return this.Room15.GetMaterialName(categ);
            case 'rom16': return this.Room16.GetMaterialName(categ);
            case 'rom17': return this.Room17.GetMaterialName(categ);
            case 'rom18': return this.Room18.GetMaterialName(categ);
            case 'rom24': return this.Room24.GetMaterialName(categ);
            case 'rom25': return this.Room25.GetMaterialName(categ);
            case 'rom26': return this.Room26.GetMaterialName(categ);
            case 'rom27': return this.Room27.GetMaterialName(categ);
            case 'rom28': return this.Room28.GetMaterialName(categ);
            case 'rom38': return this.Room38.GetMaterialName(categ);
            case 'rom39': return this.Room39.GetMaterialName(categ);
            case 'rom40': return this.Room40.GetMaterialName(categ);
            case 'rom41': return this.Room41.GetMaterialName(categ);
            case 'rom42': return this.Room42.GetMaterialName(categ);
            case 'rom43': return this.Room43.GetMaterialName(categ);
            case 'rom44': return this.Room44.GetMaterialName(categ);
            case 'rom45': return this.Room45.GetMaterialName(categ);
            case 'door': return this.Door.GetMaterialName(categ);
            case 'sash': return this.Sash.GetMaterialName(categ);
            case 'ent': return this.Ent.GetMaterialName(categ);
            case 'shutter': return this.Shutter.GetMaterialName(categ);
            default: return '';
          }
        }

        /*------------------------------------------------------
        * Textureの書き込み
        */
        public SetMaterialName(item: string, categ: string, name: string) {
          switch (item) {
            case 'out01': this.Out01.SetMaterialName(categ, name); break;
            case 'out02': this.Out02.SetMaterialName(categ, name); break;
            case 'out03': this.Out03.SetMaterialName(categ, name); break;
            case 'interior': this.Interior.SetMaterialName(categ, name);
              this.SetInteriorMat(categ, name);
              break;
            case 'rom02': this.Room02.SetMaterialName(categ, name); break;
            case 'rom03': this.Room03.SetMaterialName(categ, name); break;
            case 'rom04': this.Room04.SetMaterialName(categ, name); break;
            case 'rom05': this.Room05.SetMaterialName(categ, name); break;
            case 'rom06': this.Room06.SetMaterialName(categ, name); break;
            case 'rom07': this.Room07.SetMaterialName(categ, name); break;
            case 'rom08': this.Room08.SetMaterialName(categ, name); break;
            case 'rom09': this.Room09.SetMaterialName(categ, name); break;
            case 'rom10': this.Room10.SetMaterialName(categ, name); break;
            case 'rom11': this.Room11.SetMaterialName(categ, name); break;
            case 'rom12': this.Room12.SetMaterialName(categ, name); break;
            case 'rom13': this.Room13.SetMaterialName(categ, name); break;
            case 'rom14': this.Room14.SetMaterialName(categ, name); break;
            case 'rom15': this.Room15.SetMaterialName(categ, name); break;
            case 'rom16': this.Room16.SetMaterialName(categ, name); break;
            case 'rom17': this.Room17.SetMaterialName(categ, name); break;
            case 'rom18': this.Room18.SetMaterialName(categ, name); break;
            case 'rom24': this.Room24.SetMaterialName(categ, name); break;
            case 'rom25': this.Room25.SetMaterialName(categ, name); break;
            case 'rom26': this.Room26.SetMaterialName(categ, name); break;
            case 'rom27': this.Room27.SetMaterialName(categ, name); break;
            case 'rom28': this.Room28.SetMaterialName(categ, name); break;
            case 'rom38': this.Room38.SetMaterialName(categ, name); break;
            case 'rom39': this.Room39.SetMaterialName(categ, name); break;
            case 'rom40': this.Room40.SetMaterialName(categ, name); break;
            case 'rom41': this.Room41.SetMaterialName(categ, name); break;
            case 'rom42': this.Room42.SetMaterialName(categ, name); break;
            case 'rom43': this.Room43.SetMaterialName(categ, name); break;
            case 'rom44': this.Room44.SetMaterialName(categ, name); break;
            case 'rom45': this.Room45.SetMaterialName(categ, name); break;
            case 'door': this.Door.SetMaterialName(categ, name); break;
            case 'sash': this.Sash.SetMaterialName(categ, name); break;
            case 'ent': this.Ent.SetMaterialName(categ, name); break;
            case 'shutter': this.Shutter.SetMaterialName(categ, name); break;
            default: break;
          }
        }
}
